import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import {
  Button,
  FormField,
  FormSection, Input, InputLabel,
  SectionBody, SectionFooter,
  SectionHeader,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import { PageLoader } from '@kambria/kambria-lego';

import { logInMvp, fetchUserMvp } from 'redux/actions/user.action';
import { connect } from 'react-redux';
import warning from 'static/images/mvp/warning.png';
import './signin.scss';
import { formTheme } from './ThemeSignIn';
import utils from 'helpers/utils';
import { I18n } from '../../helpers/i18n';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.inputs = {};
    this.state = {
      redirectToReferrer: false,
      errorEmail: '',
      errorPassword: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  login = () => {
    let email = this.inputs.email?.trim();
    let password = this.inputs.password?.trim();
    let hasError = false;
    if (!email) {
      hasError = true;
      this.setState({ errorEmail: I18n.t('text_field_required_error') });
    }
    if (!password) {
      hasError = true;
      this.setState({ errorPassword: I18n.t('text_field_required_error') });
    }

    if (email && !this.validateEmail(email)) {
      hasError = true;
      this.setState({ errorEmail: I18n.t('email_invalid') });
    }
    if (hasError) {
      return;
    }
    this.setState({ errorEmail: '' });
    this.setState({ errorPassword: '' });
    const { logInMvp, fetchUserMvp } = this.props;
    return logInMvp(email, password)
      .then(result => {
        if (result && result.status == 'OK') {
          // save to storage
          let dataUser = {
            type: result.user.type,
            name: result.user.name,
            _id: result.user._id,
            accessToken: result.accessToken,
          };
          // save user info
          localStorage.setItem('ced:user-info', JSON.stringify(dataUser));
          utils.saveToCookie('_RFT', result.refreshToken, 365);

          fetchUserMvp();
          this.setState(() => ({
            redirectToReferrer: true,
          }));
        } else if (result && result.status == 'not-ok') {
          let errorMessage = result.message;
          this.setState({ errorPassword: errorMessage });
        }
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };

  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type ? checked : value;
    this.inputs['checkedValue'] = check_type ? value : null;
  }


  render() {
    const { redirectToReferrer, errorEmail, errorPassword } = this.state;
    let theme = {
      input: {
        color: '#000000',
        fontSize: '16px',
        lineHeight: '24px',
        borderColor: '#CCCCCC',
        borderRadius: '4px',
        padding: '14px 16px',
      },
    };
    if (errorEmail || errorPassword) {
      theme.input['borderColor'] = '#FF445D';
    }
    if (redirectToReferrer === true) {
      const redirectTo = sessionStorage.getItem('ced:previousUrl') || '/';
      sessionStorage.removeItem('ced:previousUrl');
      return <Redirect to={redirectTo} />;
    }

    return (
      <div id="site_wrapper">
        {this.props.header}
        <FormSection theme={formTheme}>
          <SectionHeader theme={formTheme}>{I18n.t('login')}</SectionHeader>
          <SectionBody style={{ marginBottom: 24 }}>
            <FormField>
              <InputLabel theme={formTheme}>{I18n.t('senior_account_account_info_email_label')} <span
                className="text-danger">*</span></InputLabel>
              <Input
                placeholder={I18n.t('email_hint_text')}
                key="email"
                name="email"
                theme={theme}
                onChange={this.handleInputChange}
              />
              {errorEmail && (
                <span className="error-message">
                                    <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                  {errorEmail}
                                </span>
              )}
            </FormField>
            <FormField theme={{ formField: { marginBottom: '10px' } }}>
              <InputLabel theme={formTheme}>{I18n.t('password')} <span className="text-danger">*</span></InputLabel>
              <Input
                placeholder={I18n.t('password_hint')}
                key="password"
                type="password"
                name="password"
                onChange={this.handleInputChange}
                theme={theme}
              />
              {errorPassword && (
                <span className="error-message">
                  <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                  {errorPassword}
                </span>
              )}
            </FormField>
            <Link
              to="/forgot-password"
              style={{ color: '#01ECC3', textDecoration: 'underline' }}
            >
              {I18n.t('forgot_password')}
            </Link>
          </SectionBody>
          <SectionFooter theme={formTheme}>
            <Button theme={formTheme} onClick={this.login}>
              {I18n.t('login')}
            </Button>
            <Link className="sign-up" to="/sign-up">
              {I18n.t('register_account')}
            </Link>
          </SectionFooter>
          {this.state.loading && (
            <div
              style={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                top: 0,
                background: '#0000004d',
                left: 0,
              }}
            >
              <PageLoader type="center" />
            </div>
          )}
        </FormSection>
      </div>
    );
  };
}

const mapStateToProps = ({ user }) => ({
  userInfo: user,
});

const mapDispatchToProps = { logInMvp, fetchUserMvp };

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
